import {
  jb_app_download_css_default
} from "./chunk.W5JHGPPI.js";
import {
  o
} from "./chunk.Q4XARGZW.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-app-download/jb-app-download.ts
var JbAppDownload = class extends Spaceable(i) {
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 10 };
  }
  _tracking(e) {
    const interactionText = e.detail.linkTag.href;
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "app-download",
      interaction_text: interactionText
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <div class="wrapper">
        <jb-heading variant="heading-lg">${this.headline}</jb-heading>
        ${this.text ? b`<p>${this.text}</p>` : A}
        <div class="link-code-container">
          <div
            class="links"
            @jb-link:clicked=${this._tracking}
          >
            ${this.storelinks?.map(
      (storelink) => b`<jb-anchor
                  .link=${storelink.link}
                  .ariaLabels=${{ label: storelink.ariaLabels?.label }}
                  ><img
                    src="${storelink.imgSrc}"
                    alt="${storelink.imgAlt || ""}"
                /></jb-anchor>`
    )}
          </div>
          <div class="code">
            <p>${this.qrCodeCTA}</p>
            ${o(this.qrCodeSVG)}
          </div>
        </div>
      </div>
    `;
  }
};
JbAppDownload.styles = [reset_css_default, jb_app_download_css_default];
__decorateClass([
  n({ reflect: true })
], JbAppDownload.prototype, "headline", 2);
__decorateClass([
  n()
], JbAppDownload.prototype, "qrCodeCTA", 2);
__decorateClass([
  n()
], JbAppDownload.prototype, "qrCodeSVG", 2);
__decorateClass([
  n({ type: Array })
], JbAppDownload.prototype, "storelinks", 2);
__decorateClass([
  n()
], JbAppDownload.prototype, "text", 2);
JbAppDownload = __decorateClass([
  customElement("jb-app-download")
], JbAppDownload);

export {
  JbAppDownload
};
